import type { ProductDumpApi } from 'apiConnector/productDump';
import { createContext } from 'react';

export const ProductDumpApiContext = createContext<ProductDumpApi | null>(null);
